// Metadados dos nodes do canvas do agente (porte da paleta do navisuite).
// kind -> { label, color, icon (lucide) }
export const NODE_META = {
  start: { label: 'Início', color: '#34a853', icon: 'i-lucide-play' },
  agent: { label: 'Agente', color: '#4285f4', icon: 'i-lucide-bot' },
  classify: {
    label: 'Classificar',
    color: '#f9ab00',
    icon: 'i-lucide-layout-grid',
  },
  guardrails: {
    label: 'Proteções',
    color: '#5e35b1',
    icon: 'i-lucide-shield-check',
  },
  approve: {
    label: 'Aprovação',
    color: '#00897b',
    icon: 'i-lucide-circle-check',
  },
  http_request: {
    label: 'HTTP Request',
    color: '#7e57c2',
    icon: 'i-lucide-globe',
  },
  send: { label: 'Enviar resposta', color: '#34a853', icon: 'i-lucide-send' },
  end: { label: 'Fim', color: '#34a853', icon: 'i-lucide-flag' },
  note: { label: 'Nota', color: '#9aa0a6', icon: 'i-lucide-sticky-note' },
  if_else: { label: 'Condição', color: '#7e57c2', icon: 'i-lucide-git-fork' },
  prospect: { label: 'Prospecção', color: '#00897b', icon: 'i-lucide-target' },
  tool_get_customer: {
    label: 'Buscar cliente',
    color: '#f9ab00',
    icon: 'i-lucide-user-search',
  },
  tool_search_kb: {
    label: 'Buscar KB',
    color: '#f9ab00',
    icon: 'i-lucide-book-open',
  },
  tool_business_info: {
    label: 'Dados da empresa',
    color: '#f9ab00',
    icon: 'i-lucide-building-2',
  },
  tool_catalog: {
    label: 'Consultar catálogo',
    color: '#f9ab00',
    icon: 'i-lucide-package-search',
  },
  // Opcional: sem este nó (ou com ele ligado) as ferramentas de turma
  // continuam automáticas (módulo + curso ativo). Desligado, tira as três
  // ferramentas deste agente (Agno::CourseTools).
  tool_courses: {
    label: 'Turmas (cursos e turmas)',
    color: '#f9ab00',
    icon: 'i-lucide-graduation-cap',
  },
  tool_route_agent: {
    label: 'Passar a outro agente',
    color: '#ea4335',
    icon: 'i-lucide-arrow-right-left',
  },
  tool_send_media: {
    label: 'Enviar mídia',
    color: '#4285f4',
    icon: 'i-lucide-image',
  },
  tool_capture_lead: {
    label: 'Capturar lead',
    color: '#00897b',
    icon: 'i-lucide-user-plus',
  },
  tool_deal: {
    label: 'Negócio no funil',
    color: '#00897b',
    icon: 'i-lucide-briefcase-business',
  },
  tool_update_contact: {
    label: 'Atualizar contato',
    color: '#00897b',
    icon: 'i-lucide-user-pen',
  },
  tool_create_task: {
    label: 'Criar tarefa',
    color: '#00897b',
    icon: 'i-lucide-list-checks',
  },
  tool_resolve: {
    label: 'Resolver conversa',
    color: '#ea4335',
    icon: 'i-lucide-circle-check-big',
  },
  tool_followup: {
    label: 'Agendar lembrete',
    color: '#00897b',
    icon: 'i-lucide-alarm-clock',
  },
  tool_schedule_meeting: {
    label: 'Agendar reunião',
    color: '#4285f4',
    icon: 'i-lucide-calendar-clock',
  },
  tool_apply_label: {
    label: 'Etiquetar conversa',
    color: '#00897b',
    icon: 'i-lucide-tag',
  },
  tool_internal_note: {
    label: 'Nota interna',
    color: '#fbbc04',
    icon: 'i-lucide-notebook-pen',
  },
  // A pesquisa e enviada ao resolver a conversa (pela IA ou por humano). Durante
  // a coleta, o atendimento normal fica bloqueado ate registrar ou recusar.
  tool_csat_read: {
    label: 'Avaliar atendimento',
    color: '#fbbc04',
    icon: 'i-lucide-star',
  },
  tool_escalate: {
    label: 'Escalar pra humano',
    color: '#ea4335',
    icon: 'i-lucide-arrow-up-from-line',
  },
  tool_tecimob: {
    label: 'Tecimob',
    color: '#00897b',
    icon: 'i-lucide-building-2',
  },
  tool_sienge: {
    label: 'Sienge',
    color: '#00897b',
    icon: 'i-lucide-building-2',
  },
  tool_mercado_livre: {
    label: 'Mercado Livre',
    color: '#00897b',
    icon: 'i-lucide-package-search',
  },
  tool_loja_integrada: {
    label: 'Loja Integrada',
    color: '#00897b',
    icon: 'i-lucide-shopping-bag',
  },
  tool_build_booking_link: {
    label: 'Reserva Omnibees',
    color: '#00897b',
    icon: 'i-lucide-bed-double',
  },
  phone: { label: 'Telefone', color: '#1a73e8', icon: 'i-lucide-phone' },
  // O nó NÃO dispara ligação sozinho: ele configura e sincroniza o assistente
  // de telefone e habilita o botão "Ligar com a IA" dentro da conversa. Rótulo
  // honesto até a Fase 2 (disparo pelo fluxo + receptivo) existir.
  flexcalls_call: {
    label: 'Assistente de telefone',
    color: '#1a73e8',
    icon: 'i-lucide-phone-call',
  },
  flexcalls_audio: {
    label: 'Áudio da ligação',
    color: '#1a73e8',
    icon: 'i-lucide-audio-lines',
  },
  flexcalls_transcript: {
    label: 'Transcrição',
    color: '#1a73e8',
    icon: 'i-lucide-file-text',
  },
};

// Paleta agrupada por seção (arrastável). Cada seção tem ícone+cor pra coluna
// de ícones; clicar abre o submenu com os itens. 'start' não entra — já existe.
export const PALETTE = [
  {
    section: 'Blocos',
    icon: 'i-lucide-box',
    color: '#4285f4',
    items: [
      'agent',
      'classify',
      'guardrails',
      'approve',
      'http_request',
      'if_else',
      'send',
      'end',
      'note',
    ],
  },
  {
    section: 'Buscar dados',
    icon: 'i-lucide-database',
    color: '#f9ab00',
    items: [
      'tool_get_customer',
      'tool_search_kb',
      'tool_business_info',
      'tool_catalog',
      'tool_courses',
    ],
  },
  {
    section: 'Mídia',
    icon: 'i-lucide-image',
    color: '#4285f4',
    items: ['tool_send_media'],
  },
  {
    section: 'CRM / Leads',
    icon: 'i-lucide-users',
    color: '#00897b',
    items: [
      'tool_capture_lead',
      'tool_deal',
      'tool_update_contact',
      'tool_create_task',
      'tool_followup',
      'tool_schedule_meeting',
      'tool_apply_label',
      'tool_resolve',
    ],
  },
  {
    section: 'Prospecção',
    icon: 'i-lucide-target',
    color: '#00897b',
    items: ['prospect'],
  },
  {
    section: 'Operação',
    icon: 'i-lucide-wrench',
    color: '#ea4335',
    items: [
      'tool_internal_note',
      'tool_csat_read',
      'tool_escalate',
      'tool_route_agent',
    ],
  },
  {
    section: 'Integrações',
    icon: 'i-lucide-plug',
    color: '#00897b',
    items: [
      'tool_tecimob',
      'tool_sienge',
      'tool_loja_integrada',
      'tool_mercado_livre',
      'tool_build_booking_link',
    ],
  },
  // Seção "Voz" (nó `phone`, voz da IA via WaCalls) FORA da paleta enquanto a
  // experiência não está boa: ninguém adiciona em agente novo. O tipo `phone`
  // segue vivo em NODE_META, no inspector e no payload de voz — os agentes que
  // já têm o nó continuam renderizando, editando e atendendo normalmente.
  // Para trazer de volta, basta reinserir a seção aqui.
  {
    section: 'Ligação (FlexCalls)',
    icon: 'i-lucide-phone-call',
    color: '#1a73e8',
    items: ['flexcalls_call', 'flexcalls_audio', 'flexcalls_transcript'],
  },
].map(s => ({
  section: s.section,
  icon: s.icon,
  color: s.color,
  items: s.items.map(kind => ({
    kind,
    label: NODE_META[kind].label,
    color: NODE_META[kind].color,
  })),
}));

// Nós de ação da Fase 1: só aparecem na paleta das contas liberadas
// (Agno::ActionTools no servidor; o agente traz action_tools_enabled).
// Agente que já tem o nó continua renderizando normalmente.
export const ACTION_TOOL_KINDS = [
  'tool_deal',
  'tool_update_contact',
  'tool_create_task',
  'tool_resolve',
];

export const paletteFor = ({ actionTools }) =>
  actionTools
    ? PALETTE
    : PALETTE.map(section => ({
        ...section,
        items: section.items.filter(
          item => !ACTION_TOOL_KINDS.includes(item.kind)
        ),
      }));

// Família VISUAL do nó (a forma do card). O olho aprende 5 formas, não 30:
//   trigger = pílula (só saída) · agent = herói · flow = card branco ·
//   logic = cabeçalho colorido + saídas rotuladas · tool = compacto tintado ·
//   note = post-it.
export const LOGIC_KINDS = ['if_else', 'classify', 'guardrails', 'approve'];
export const isToolKind = kind =>
  !!kind &&
  (kind.startsWith('tool_') ||
    kind === 'http_request' ||
    kind.startsWith('flexcalls_') ||
    kind === 'phone');

export const familyOf = kind => {
  if (kind === 'start' || kind === 'prospect') return 'trigger';
  if (kind === 'agent') return 'agent';
  if (kind === 'note') return 'note';
  if (LOGIC_KINDS.includes(kind)) return 'logic';
  if (isToolKind(kind)) return 'tool';
  return 'flow';
};

// Categoria da paleta (rótulo + cor) por kind — é a etiqueta que aparece no
// card das ferramentas. Kinds fora da paleta entram à mão.
export const CATEGORY_OF = (() => {
  const map = {};
  PALETTE.forEach(section => {
    section.items.forEach(item => {
      map[item.kind] = { label: section.section, color: section.color };
    });
  });
  map.http_request = { label: 'Integrações', color: '#00897b' };
  map.phone = { label: 'Ligação', color: '#1a73e8' };
  return map;
})();
